import React, { useEffect, useState } from 'react'
import {
  GetUserNotifications$Request,
  NotificationId,
  NotificationType,
  UserNotificationDto,
} from '../../services/api.types'
import NotificationsWrapper from '../../components/Notification/NotificationsWrapper'
import { Card } from '../../components/Card/Card'
import { t } from 'ttag'
import { isRtl } from '../../i18nInit'
import Loader from '../../components/Loader/Loader'
import UserNotificationWrapper from './components/UserNotification/UserNotificationWrapper'
import YumTabs from '../../components/YumTabs/YumTabs'
import YumTab from '../../components/YumTabs/YumTab/YumTab'
import YumButton from '../../components/YumButton/YumButton'
import { isNative } from '../../common/helpers/isNative'
import YumEmptyState from '../../components/YumEmptyState/YumEmptyState'

import { ReactComponent as EmptyStateIcon } from '../../assets/v3/icons/notifications/empty-state.svg'
import YumHeader from '../../components/YumHeader/YumHeader'
import Box from '@material-ui/core/Box'
import { ReactComponent as FilterIconNew } from '../../assets/v3/icons/ranking/filter.svg'
import { ROUTES } from '../../common/Routes/routePaths'
import { store } from '../../index'
import { push } from 'connected-react-router'
import { Redirect } from 'react-router-dom'
import { PluginListenerHandle } from '@capacitor/core'
import { App } from '@capacitor/app'
import { useHistory } from 'react-router'

export interface IInboxProps {
  notificationId: NotificationId
  userNotifications: UserNotificationDto[]
  isLoading: boolean
  isPush: boolean
}

export interface IInboxDispatchProps {
  getUserNotifications(payload: GetUserNotifications$Request): void
}

export default function Inbox(props: IInboxProps & IInboxDispatchProps) {
  const { notificationId, userNotifications, isLoading, isPush, getUserNotifications } = props
  const history = useHistory()

  if (!notificationId) {
    setTimeout(() => history.push('/inbox/announcements'), 0)
    //setTimeout(() => store.dispatch(push('/inbox/announcements')), 0)
    return null
    // return <Redirect to="/inbox/announcements" />
  }

  const loading = !userNotifications && isLoading

  //const [openNotificationId, setOpenNotificationId] = useState(notificationId)

  const isNotification = userNotifications.find(
    (n) => n.type === NotificationType.NOTIFICATION && n.notificationId === notificationId,
  )
  const [activeTab, setActiveTab] = useState(
    isNotification ? NotificationType.NOTIFICATION : NotificationType.ANNOUNCEMENT,
  )
  const [visibleNotifications, setVisibleNotifications] = useState<UserNotificationDto[]>([])

  useEffect(() => {
    if (!notificationId.includes('/')) {
      setActiveTab(
        notificationId === 'notifications' || isNotification
          ? NotificationType.NOTIFICATION
          : NotificationType.ANNOUNCEMENT,
      )
    }
  }, [notificationId])

  useEffect(() => {
    getUserNotifications({})

    let appStateChangeListener: PluginListenerHandle | undefined
    const addListener = async () => {
      appStateChangeListener = await App.addListener('appStateChange', async ({ isActive }) => {
        if (isActive) {
          getUserNotifications({})
        }
      })
    }
    addListener().catch(console.error)

    return () => {
      if (appStateChangeListener) {
        try {
          appStateChangeListener.remove()
        } catch (error) {
          console.error('Inbox | appStateChangeListener.remove() error', error)
        }
      }
    }
  }, [])

  /*useEffect(() => {
    // TODO: Check if active notification is actually in the "notifications" tab.
    const isNotification = userNotifications.find(
      (n) => n.type === NotificationType.NOTIFICATION && n.notificationId === notificationId,
    )
    if (isNotification) {
      setActiveTab(NotificationType.NOTIFICATION)
    }
  }, [userNotifications])*/

  useEffect(() => {
    setVisibleNotifications(userNotifications.filter((n) => n.type === activeTab))
  }, [userNotifications, activeTab])

  useEffect(() => {
    if (isPush) {
      getUserNotifications({})
    }
  }, [isPush])

  const isFirstRun = React.useRef(true)
  useEffect(() => {
    if (isFirstRun.current || isPush) {
      isFirstRun.current = false
      if (notificationId) {
        if (notificationId === 'notifications') {
          setActiveTab(NotificationType.NOTIFICATION)
        } else {
          if (isPush) {
            if (isNotification) {
              setActiveTab(NotificationType.NOTIFICATION)
            } else {
              setActiveTab(NotificationType.ANNOUNCEMENT)
            }
          }
          setTimeout(() => {
            const element = document.getElementById('n-' + String(notificationId))
            if (element) {
              if (isNative()) {
                // const top = element.getBoundingClientRect().top + window.pageYOffset - window.innerHeight / 2
                const scrollableDiv = document.getElementById('content')
                if (scrollableDiv) {
                  // TODO: Should we account for safe area of the header nav?
                  // TODO: Wrong position for android
                  const headerHeight = document.querySelectorAll<HTMLElement>('.layout__header')[0]?.offsetHeight || 0
                  const elementTop = element.offsetTop - scrollableDiv.offsetTop + headerHeight - 15
                  scrollableDiv.scrollTo({ top: elementTop, behavior: 'smooth' })
                  // document.getElementById('content')?.scrollTo({ top, behavior: 'smooth' })
                }
              } else {
                element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
              }
            }
          }, 100)
        }
      }
      return
    }
  }, [visibleNotifications, notificationId])

  /*useEffect(() => {
    // Set up an interval to update the time every minute
    const interval = setInterval(() => {
      getUserNotifications({})
    }, 60000) // 60000 ms = 1 minute

    // Clean up the interval when the component is unmounted
    return () => clearInterval(interval)
  }, [])*/

  const handleTabChange = (event: React.ChangeEvent<unknown>, newTab: NotificationType) => {
    setActiveTab(newTab)
    store.dispatch(push(`/inbox/${newTab === NotificationType.NOTIFICATION ? 'notifications' : 'announcements'}`))
  }

  return (
    <Card>
      <NotificationsWrapper />
      <YumHeader>
        <h1>
          {t`Inbox`}
          {!loading && (
            <span style={{ opacity: 0.5, whiteSpace: 'nowrap' }}>
              {' '}
              ({userNotifications.filter((n) => !n.read).length})
            </span>
          )}
        </h1>
        <YumButton variant="outlined" size="small" to={ROUTES.NOTIFICATION_SETTINGS.to}>
          <FilterIconNew />
          <Box
            display={{ xs: 'none', md: 'inline' }}
            style={isRtl ? { marginRight: '6px' } : { marginLeft: '6px' }}
          >{t`Preferences`}</Box>
        </YumButton>
      </YumHeader>
      <YumTabs
        onChange={handleTabChange}
        value={activeTab}
        style={{ marginBottom: '20px', backgroundColor: '#F5F5F9' }}
      >
        <YumTab label={t`Announcements`} value={NotificationType.ANNOUNCEMENT} />
        <YumTab label={t`Notifications`} value={NotificationType.NOTIFICATION} />
      </YumTabs>
      {loading ? (
        <Loader />
      ) : !visibleNotifications.length ? (
        <YumEmptyState
          text={
            activeTab === NotificationType.ANNOUNCEMENT
              ? t`No announcements here yet...`
              : t`No notifications here yet...`
          }
          Icon={EmptyStateIcon}
        />
      ) : (
        <>
          <div>
            {visibleNotifications &&
              visibleNotifications.map((n, i) => (
                <UserNotificationWrapper
                  key={n.id}
                  notification={n}
                  isOpen={n.notificationId === notificationId}
                  isNotification={isNotification}
                />
              ))}
          </div>
        </>
      )}
    </Card>
  )
}
